var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlug = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#plug_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.747.16a1 1 0 0 0-1 1v3.614h-.461a2 2 0 0 0-2 2v2.041c0 3.78 3.079 6.592 6.7 7.04V19a1 1 0 1 0 2 0v-3.142c3.634-.437 6.728-3.253 6.728-7.043v-2.04a2 2 0 0 0-2-2h-.442V1.16a1 1 0 1 0-2 0v3.614H6.747V1.16a1 1 0 0 0-1-1"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "plug_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h20v20H0z"
})))));
SvgPlug.displayName = "SvgPlug";
export { SvgPlug as ReactComponent };
export default SvgPlug;